var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.type,_vm._b({tag:"component",attrs:{"isDialog":_vm.isDialog,"code":_vm.meta.code || _vm.meta.id,"configH":_vm.isHeight,"layout":_vm.layout,"labelWidth":_vm.labelWidth|| 120,"meta":_vm.meta,"initCheckboxVal":_vm.initCheckboxVal}},'component',_vm.meta,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-193136d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/config/index.vue
// module id = null
// module chunks = 